import { createClient } from '@supabase/supabase-js';

// These credentials are required for the application to interact with Supabase services.
const SUPABASE_URL = "https://hhvzikakktakbcdbaqxj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhodnppa2Fra3Rha2JjZGJhcXhqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI4MTg5NTgsImV4cCI6MjA4ODM5NDk1OH0.81vshbMO9WwsjX0I-HHR55uRZwL7hbI8MB016gKuNRc";

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);